import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { ValueAdditionTwoType } from "../value-addition-two.entity";
import { ValueAdditionTwoDTO } from "./value-addition-two.dto";

export class ValueAddTwoTypeAdapter {
    convertDtoToEntity(dtoObj: ValueAdditionTwoDTO,  isUpdate: boolean = false ): ValueAdditionTwoType {
        try {
            const entityObj = new ValueAdditionTwoType();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.code = dtoObj.code;
            entityObj.name = dtoObj.name;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.valueAdditionTwoId) {
                entityObj.valueAdditionTwoId = dtoObj.valueAdditionTwoId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: ValueAdditionTwoType): ValueAdditionTwoDTO {
        const foodTypeDetailsDTO= new ValueAdditionTwoDTO;
        foodTypeDetailsDTO.valueAdditionTwoId = employeeObject.valueAdditionTwoId;
        foodTypeDetailsDTO.code = employeeObject.code;
        foodTypeDetailsDTO.name = employeeObject.name;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}